export default {
  sorting: {
    title: 'Сортировать',
    default: 'По умолчанию',
    rank: 'По популярности',
    published_at: 'По новизне',
    rating: 'По отзывам',
  },
};
